import React, { FC } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import sortBy from 'lodash/sortBy';
import moment from 'moment';

import { Modal } from 'src/shared/components';
import { API_DATE_FORMAT, DAY_COMMA_DATE_FORMAT } from 'src/shared/constants';
import { useTranslate } from 'src/shared/providers';

interface Props {
  dates: string[];
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  loading?: boolean;
}

export const EmployeeAvailabilitySubmitModal: FC<Props> = ({ open, dates, onClose, onSubmit, loading }) => {
  const { t } = useTranslate();

  return (
    <Modal
      modalHeaderProps={{ title: t('availability.youveSpecifiedAvailabilityFor'), onClose }}
      modalFooterProps={{
        submitText: t('global.save'),
        onSubmit,
        closeText: t('global.cancel'),
        onClose,
        loading,
        disabled: loading,
      }}
      open={open}
      onClose={onClose}
    >
      <Stack direction="column" gap={2}>
        <Typography>{t('availability.thisActionWillOverwriteRecurringAvailabilityForTheSpecifiedDate')}</Typography>
        <Stack direction="column" component="ul" gap={1}>
          {sortBy(dates).map((date, index) => (
            <li key={`${date}-${index}`}>
              <Typography fontWeight={500} sx={{ display: 'block' }}>
                {moment(date, API_DATE_FORMAT).format(DAY_COMMA_DATE_FORMAT)}
              </Typography>
            </li>
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
};
